<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">取样履历</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name" >
        <span class="">取样履历</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="margin-top: 15px;">
          <!--第一行-->
          <div class="sampling-first-title" style="padding:0px;">
              <h4>基础信息</h4>
          </div>
          <!--第二行内容-->
          <div class="sampling-first-content">
              <!--第1行-->
              <div style="font-size: 14px;">
                  <div class="sampling-first-content-left">
                      <span>外注订单:</span>
                  </div>
                  <div class="flex-8">
                      <span>{{paraInfo.ddh}}</span>
                  </div>
              </div>
              <!--第2行-->
              <div style="font-size: 14px;">
                  <div class="sampling-first-content-left">
                      <span>物料:</span>
                  </div>
                  <div class="flex-8">
                      <span>{{paraInfo.scxtwph+" "+paraInfo.scxtwpmc}}</span>
                  </div>
              </div>
          </div>
      </div>

      <div class="sampling-first" style="border-bottom: 0px;">
          <!--第一行-->
          <div class="sampling-first-title">
              <h4>取样明细</h4>
          </div>
          <!--第二行内容-->
          <div class="sampling-first-content">
            <ul  class="mui-table-view">
              <li class="mui-table-view-cell flex-content" style="display: block;margin-bottom: 10px;"  v-for="(info,i) in sampleList" :id="info.sampleno">
                <div class="mui-slider-right mui-disabled">
                  <a class="mui-btn mui-btn-yellow" @tap="determine(info)">查看详情</a>
                  <a class="mui-btn mui-btn-red" v-if="info.determinegrade==''"  @tap="delsample(info.sampleno)">删除</a>
                </div>
                <div class="mui-slider-handle">
                  <div class="mui-table-cell">
                    <!--第一个-->
                    <!-- <div class=""> -->
                      <div class="flex-box">
                        <div class="flex-container">
                          <div class="flex-content-container flex-4">
                              <div class="flex-content-label"style="text-align: left;padding-right: 0px;">取样日期：</div>
                              <div class="flex-content-span flex-5">{{info.sampletime}}</div>
                          </div>
                          <div class="flex-content-container flex-1">
                              <div class="flex-content-label" style="min-width: 0px;text-align: left;padding-right: 0;"></div>
                              <div class="flex-content-span flex-1">No:{{(i+1)}}</div>
                          </div>
                        </div>
                        <div class="flex-container">
                            <div class="flex-content-container flex-4">
                              <div class="flex-content-label" style="text-align: left;min-width: 76px;padding-right: 0px;">取样单号：</div>
                              <div class="flex-content-span flex-1">{{info.sampleno}}</div>
                            </div>
                            <div class="flex-content-container flex-3">
                              <div class="flex-content-label" style="min-width: 35px;"></div>
                              <div class="flex-content-span flex-strong flex-1" style="display: flex;">
                                <div style="text-align: center;min-width: 60px;">{{info.determinegrade}}</div>
                                <div style="flex: 1;"></div>
                              </div>
                            </div>
                        </div>
                        <div class="flex-container">
                          <div class="flex-content-container flex-4">
                              <div class="flex-content-label" style="text-align: left;padding-right: 0px;">取样卷号：</div>
                              <div class="flex-content-span flex-2">{{info.wzrollno}}</div>
                          </div>
                        </div>
                        <div class="flex-container">
                          <div class="flex-content-container flex-4">
                              <div class="flex-content-label" style="text-align: right;padding-right: 0px;">取 样 人：</div>
                              <div class="flex-content-span flex-2">{{info.sampleuser}}</div>
                          </div>
                        </div>
                      </div>       
                    <!-- </div> -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
      </div>
</div>

  </section>
</template>

<script>
    export default {
      name: "samplingWeavingHis",
      data(){
        return{
          paraInfo:{ddh:"",wph:"",scxtwph:"",scxtwpmc:"" },
          sampleList:[]
        // {sampleno:"QY181100002",determinegrade:"C（停机）",tsdrollno:"12-0101-683/684",sampletime:"2018/11/05",sampleuser:"小李"},
        // {sampleno:"QY181100002",determinegrade:"C（停机）",tsdrollno:"12-0101-683/684",sampletime:"2018/11/05",sampleuser:"小李"}
        }
      },
      methods:{
        determine(info){
          var v=this;
          var li=document.getElementById(info.sampleno);
          setTimeout(function() {
                mui.swipeoutClose(li);
          }, 0);
          v.paraInfo.sampleno=info.sampleno;
          v.paraInfo.determineuserflg=info.determineuserflg;
          v.$router.push({"name":"samplingWeavingDetermine",params: jsonPara(v.paraInfo)});
        },
        delsample(sampleno){
          var v=this;
          var li=document.getElementById(sampleno);
          mui.confirm('是否删除该取样？', '系统消息', ['确认', '取消'], function(e) {
            if(e.index==0){
              v.nyy.doPost("/Sample/deleteSample",{sampleno:sampleno}, 
                function(result){
                  if(result.status){
                    v.query();
                  } else {
                    mui.toast(result.message);
                    return;
                  }
                }
              );
            }
            setTimeout(function() {
                mui.swipeoutClose(li);
            }, 0);
          });
        },
        query(){
          var v=this;
          v.nyy.doPost("/Sample/getSampleList",v.paraInfo, 
            function(result){
              if(result.status){
                 v.sampleList=result.data.infoLst;
              }else {
                mui.toast(result.message);
                return;
              }
            }
          );
        }
      },
      activated() {
        var v=this;
        v.paraInfo = getJsonPara(v.$route);
        v.query();
      }
    }
</script>

<style scoped>
  @import "../../static/css/sampling.css";
  @import "../../static/css/samplinghistory.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingWeavingHis.vue